import { render } from "./collapse.vue?vue&type=template&id=54e9c67b&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=54e9c67b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54e9c67b"

export default script